<template>
  <section class="navbar">
    <div class="navbar__left">
      <a :href="data.market.url" target="_blank">
        <img
          class="navbar__left--logo"
          :src="require(`../assets/images/${data.navbar.logo}.png`)"
          :alt="data.navbar.logo"
        />
      </a>
    </div>
    <div class="navbar__right">
      <div
        v-if="data.navbar.country_toggle.length > 0"
        class="navbar__right--toggle"
        @click="showToggles = !showToggles"
      >
        <img
          :src="
            require(`../assets/icons/${data.navbar.country_toggle[0].logo}.svg`)
          "
          :alt="data.navbar.country_toggle"
        />
      </div>
      <div
        v-if="showToggles"
        class="navbar__right--list animate__animated animate__bounceInDown"
      >
        <a
          v-for="(toggle, i) in data.navbar.country_toggle.slice(
            1,
            data.navbar.country_toggle.length
          )"
          :key="`toggle_${i}`"
          :href="toggle.url"
        >
          <img
            :src="require(`../assets/icons/${toggle.logo}.svg`)"
            :alt="data.navbar.country_toggle"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      showToggles: false,
    }
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.navbar {
  margin-bottom: -10px;
  background-color: var(--color-orange-1);
  padding: 20px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  &__left {
    display: flex;
    align-items: flex-end;
    &:hover {
      transform: scale(1.02);
    }
    @media (max-width: $tablet) {
      flex-direction: column;
      width: 60%;
      align-items: flex-start;
    }
    &--logo {
      width: 200px;
      padding: 0 10px 0 0;
      margin: 0;
      cursor: pointer;
      @media (max-width: $tablet) {
        width: 150px;
        padding: 0;
      }
    }
    &--title {
      color: var(--color-white-1);
      font-weight: 600;
      @media (max-width: $tablet) {
        flex-direction: column;
        padding: 10px 0;
      }
    }
  }
  &__right {
    display: flex;
    align-items: self-start;
    &--button {
      padding: 8px;
      background-color: transparent;
      border: 2px solid var(--color-white-1);
      border-radius: 30px;
      cursor: pointer;
      color: var(--color-white-1);
      text-decoration: none;
      display: flex;
      max-width: 200px;
      justify-content: space-evenly;
      align-items: center;
      img {
        margin-right: 2px;
      }
      &:hover {
        transform: scale(1.03);
      }
    }
    &--toggle {
      margin: 0 10px 0 0;
      padding: 0;
      cursor: pointer;
      &:hover {
        transform: scale(1.03);
      }
      img {
        width: 50px;
        border-radius: 30px;
        border: 2px solid var(--color-white-1);
      }
    }
    &--list {
      background-color: var(--color-white-1);
      padding: 10px 10px 5px;
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 80px;
      right: 5%;
      img {
        width: 50px;
        border-radius: 30px;
        margin: 0;
        &:hover {
          transform: scale(1.03);
        }
      }
    }
  }
}
</style>